import { render, staticRenderFns } from "./Fund-NavViewBack.vue?vue&type=template&id=18c089cf&scoped=true&"
import script from "./Fund-NavViewBack.vue?vue&type=script&lang=js&"
export * from "./Fund-NavViewBack.vue?vue&type=script&lang=js&"
import style0 from "./Fund-NavViewBack.vue?vue&type=style&index=0&id=18c089cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c089cf",
  null
  
)

export default component.exports